<template>
  <div class="interactive3d">
    <div v-if="toLoad">
      <three-d key="interactive-three-d" :attributes="attributes"></three-d>
    </div>
    <div class="interactive3d-viewar" v-if="!attributes.noar">
      <viewar :attributes="{ioslink: attributes.ioslink, androidlink:attributes.androidlink, default:true}"/>
    </div>
  </div>
</template>

<script>
import ThreeD from './3D/index.vue'
import Viewar from './viewar.vue'
import throttle from 'lodash/throttle'

export default {
  props: ['attributes'],
  components: {
    ThreeD,
    Viewar
  },
  data () {
    return {
      toLoad: false
    }
  },
  methods: {
    isVisible (el, offsetTop = 0.7, offsetBottom = 0.3) {
      if (!el) return false
      const rect = el.getBoundingClientRect()
      const isVisible =
        rect.bottom > rect.height * +offsetBottom &&
        rect.right > 0 &&
        rect.left < (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */ &&
        rect.top < (window.innerHeight || document.documentElement.clientHeight) * +offsetTop /* or $(window).height() */

      return isVisible
    }
  },
  mounted () {
    const _this = this
    document.addEventListener('scroll', throttle(function () {
      if (!_this.toLoad && _this.isVisible(_this.$el, 1, 0)) {
        _this.toLoad = true
      } else if (!_this.isVisible(_this.$el, 1, 0)) {
        _this.toLoad = false
      }
    }, 100))
  }
}
</script>
<style lang="scss">
.interactive3d {
  .interactive3d-viewar {
    text-align: center;
  }
}
</style>
